export default __webpack_public_path__ + "static/media/tree_2_anim.b2a1ef61.gif";